module.exports = __webpack_public_path__ + "img/chef2o.bbb72d37.svg";